import polyfillObjectFit from 'object-fit-images';
import 'element-closest-polyfill';

export default function app(onReady) {
    function startApp() {
        polyfillObjectFit();
        if (window.ha.polyfilled === true) {
            onReady();
        } else {
            window.ha = window.ha || {};
            window.ha.main = onReady;
        }
    }

    const readyState = document.readyState;
    if (readyState === 'interactive' || readyState === 'complete') {
        startApp();
    } else {
        document.addEventListener('DOMContentLoaded', startApp);
    }
}
